import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

export class HtmlEmbedBlot extends BlockEmbed {
  static create(value: any) {
    const node = super.create();
    node.innerHTML = value;
    return node;
  }

  static value(node: HTMLElement) {
    return node.innerHTML;
  }
}

// HtmlEmbedBlot.blotName = 'html';
// HtmlEmbedBlot.tagName = 'div';

Quill.register(HtmlEmbedBlot);
